function sanitizeFilename(filename: string) {
  return filename.replace(/[^-\w]+/gi, '_');
}

export {sanitizeFilename};
